window.addEventListener( 'DOMContentLoaded', () => {

	/**
	 * Handle the click event on the copy button
	 */
	const handleCopyButton = () => {

		const copyButton = document.querySelector( '.b-share .c-share-button--copy' )

		if ( copyButton ) {

			copyButton.addEventListener( 'click', ( event ) => {

				event.preventDefault()
				const shareLink = copyButton.getAttribute( 'data-share-link' )

				document.addEventListener( 'copy', ( e ) => {

					e.clipboardData.setData( 'text/plain', shareLink )
					e.preventDefault()

				}, true )

				document.execCommand( "copy" )

				const status = copyButton.querySelector( '.c-item__button-status' )

				if ( status ) {

					status.classList.add( 'c-item__button-status--active' )

					setTimeout( () => {

						status.classList.remove( 'c-item__button-status--active' )

					}, 1500 )

				}

			} )

		}

	}

	handleCopyButton()

} )